module.exports = __webpack_public_path__ + "static/media/emissor-r-2.70046a10.png";